/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import { PlayableVodItem, VodItem } from 'client-code/vod-browse';

/* eslint-disable no-shadow */
export enum VodScreenType {
    ON_DEMAND_EPISODES_SCREEN = 'on-demand-episodes',
    VOD_GALLERY_SCREEN = 'vod-browse-gallery',
    VOD_MAIN_SCREEN = 'vod-browse-main',
    VOD_MY_RENTAL_LIST_SCREEN = 'vod-rental-list',
    VOD_PROGRAM_SCREEN = 'program-screen',
    VOD_SERIES_SCREEN = 'series-screen',
    VOD_INFO_CARD = 'vod-info-card',
}

export enum VodEntitlementType {
    Subscribable = 'Subscribable',
    Rentable = 'Rentable',
    Free = 'Free',
    Subscribed = 'Subscribed',
    Rented = 'Rented',
    NotPurchaseable = 'NotPurchaseable',
    Purchasable = 'Purchasable',
    FreeZeroPurchasable = 'FreeZeroPurchasable',
    FreeNoPurchase = 'FreeNoPurchase',
    Unknown = 'Unknown',
}

export enum TrickPlayRestrictionType {
    FAST_FORWARD = 'FastForward',
    PAUSE = 'Pause',
    REWIND = 'Rewind',
}

export enum VodCompnentsType {
    ContentRentalImage = 'ContentRentalImage',
    StatusMessage = 'StatusMessage',
    Title = 'Title',
    EpisodeInfo = 'EpisodeInfo',
    Description = 'Description',
    ShowAttributes = 'ShowAttributes',
    RatingGenres = 'RatingGenres',
    Duration = 'Duration',
    StarRating = 'StarRating',
    Cast = 'Cast',
    Source = 'Source',
    TrickplayRestriction = 'TrickplayRestriction',
    DurationWithStarRating = 'DurationWithStarRating',
}

export interface VodPreviewProps {
    screenType: VodScreenType;
    item: VodItem | PlayableVodItem;
}
